<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="85%"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                        <v-form
                            class="cardWrap__fromArea"
                            ref="member_form"
                            v-model="valid"
                            :lazy-validation="lazy"
                        >
                            <v-container>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">氏名カナ</div>
                                    <v-text-field
                                        :disabled="changeStatus"
                                        class="px-3"
                                        :rules="[rules.required_family_name_kana, rules.max_length_family_name_kana, rules.format_katakana]"
                                        v-model="from_set_data.family_name_kana"
                                        label="姓"
                                        required
                                    />
                                    <v-text-field
                                        class="px-3"
                                        :disabled="changeStatus"
                                        :rules="[rules.required_given_name_kana, rules.max_length_given_name_kana, rules.format_katakana]"
                                        v-model="from_set_data.given_name_kana"
                                        label="名"
                                        required
                                    />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">氏名</div>
                                    <v-text-field
                                        :disabled="changeStatus"
                                        class="px-3"
                                        :rules="[rules.required_family_name, rules.max_length_family_name]"
                                        v-model="from_set_data.family_name"
                                        label="姓"
                                        required
                                    />
                                    <v-text-field
                                        class="px-3"
                                        :disabled="changeStatus"
                                        :rules="[rules.required_given_name, rules.max_length_given_name]"
                                        v-model="from_set_data.given_name"
                                        label="名"
                                        required
                                    />
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">性別</div>
                                    <v-radio-group class="px-3" v-model="from_set_data.gender" row :disabled="changeStatus">
                                        <v-radio label="男性" value="0"></v-radio>
                                        <v-radio label="女性" value="1"></v-radio>
                                    </v-radio-group>
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">生年月日</div>
                                    <v-menu ref="menu" :disabled="changeStatus" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                class="px-3"
                                                :disabled="changeStatus"
                                                label="生年月日"
                                                inputmode="tel"
                                                type="tel"
                                                maxlength="10"
                                                v-on="on"
                                                @focus="focusDate(from_set_data.birth_date)"
                                                @input="from_set_data.birth_date = $event"
                                                :value="formatedDate(from_set_data.birth_date)"
                                                @keyup.delete="deleteKeyUp($event)"
                                                @keyup="from_set_data.birth_date = formatDate(from_set_data.birth_date)"
                                                :rules="[
                                                    rules.required_birth_date,
                                                    rules.string_type,
                                                    rules.format_date,
                                                    rules.correct_date
                                                ]"
                                                required
                                            />
                                        </template>
                                        <v-date-picker
                                            ref="picker"
                                            v-model="from_set_data.birth_date"
                                            :max="new Date().toISOString().substr(0, 10)"
                                            min="1900-01-01"
                                        />
                                    </v-menu>
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">メールアドレス</div>
                                    <v-text-field
                                        class="px-3"
                                        :disabled="changeStatus"
                                        v-model="from_set_data.email"
                                        label="メールアドレス"
                                        :rules="[rules.required_email, rules.format_email, rules.max_length_email]"
                                        required
                                    />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">携帯番号</div>
                                    <v-text-field
                                        class="px-3"
                                        :disabled="changeStatus"
                                        v-model="from_set_data.mobile_number"
                                        label="携帯番号"
                                        :rules="[rules.required_mobile_number, rules.format_mobile_number, rules.max_length_mobile_number]"
                                        required
                                    />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">郵便番号</div>
                                    <v-text-field
                                        :disabled="changeStatus"
                                        class="px-3"
                                        :rules="[rules.required_zipcode, rules.format_zipcode, rules.max_length_zipcode]"
                                        v-model="from_set_data.zipcode"
                                        label="郵便番号"
                                        required
                                    />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">住所</div>
                                    <v-text-field
                                        :disabled="changeStatus"
                                        class="px-3"
                                        :rules="[rules.required_address, rules.max_length_address]"
                                        v-model="from_set_data.address1"
                                        label="住所"
                                        required
                                    />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title"></div>
                                    <v-text-field
                                        :disabled="changeStatus"
                                        class="px-3"
                                        :rules="[rules.max_length_address]"
                                        v-model="from_set_data.address2"
                                        label="住所"
                                        required
                                    />
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">WEB会員種別</div>
                                    <v-radio-group
                                        row
                                        v-model="from_set_data.member_rank"
                                        :disabled="modeStatus === 'checkData'"
                                        class="px-3"
                                        >
                                        <v-radio
                                            v-for="item in items"
                                            :key="item.name"
                                            :label="item.code_name"
                                            :value="item.code"></v-radio>
                                    </v-radio-group>
                                </v-row>
                                <v-row justify="space-around" v-if="!addStatus">
                                    <div class="cardWrap__fromArea__title">パスワード</div>
                                    <v-text-field
                                        :type="show_password ? 'text' : 'password'"
                                        class="px-3"
                                        v-model="from_set_data.password"
                                        :rules="[rules.required_password, rules.format_password, rules.format_password_complexity, rules.max_length_password, rules.min_length_password]"
                                        label="パスワード" />
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-actions>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                        <v-btn v-if="modeStatus === 'addMember'" color="green darken-4" text @click="validateCheck" :disabled="btn[0].isActive">追加</v-btn>
                        <v-btn v-if="modeStatus === 'checkData'" color="green darken-4" text @click="InfoChangeData" :disabled="btn[1].isActive">変更</v-btn>
                        <v-btn v-if="modeStatus === 'changeData'" color="green darken-4" text @click="removeOverlay = !removeOverlay" :disabled="btn[2].isActive">削除</v-btn>
                        <v-btn v-if="modeStatus === 'changeData'" color="green darken-4" text @click="validateCheck">変更</v-btn>
                    </v-card-actions>
                    <v-overlay :value="removeOverlay">
                        <v-card light width="500px">
                            <v-card-title v-if="result === ''">会員情報削除の最終確認</v-card-title>
                            <v-card-title v-if="result !== ''">会員情報削除</v-card-title>
                            <v-card-text v-if="result === ''">{{ from_set_data.full_name }}さんの会員情報を削除します。<br>削除後、情報の復元はできません。</v-card-text>
                            <v-card-text v-if="result !== ''">{{ resultText }}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="result === ''" color="primary" text @click="removeOverlay = !removeOverlay">キャンセル</v-btn>
                                <v-btn v-if="result === ''" color="primary" text @click="removeMember">削除</v-btn>
                                <v-btn v-if="result !== ''" color="primary" text @click="CloseModal">閉じる</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-overlay>
                    <v-overlay :value="changeOverlay">
                        <v-card light width="500px">
                            <v-card-title v-if="result === ''">会員情報変更の最終確認</v-card-title>
                            <v-card-title v-if="result !== ''">会員情報変更</v-card-title>
                            <v-card-text v-if="result === ''">{{ from_set_data.full_name }}さんの会員情報を変更します。</v-card-text>
                            <v-card-text v-if="result !== ''">{{ resultText }}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="result === ''" color="primary" text @click="changeOverlay = !changeOverlay">キャンセル</v-btn>
                                <v-btn v-if="result === ''" color="primary" text @click="changeMember">変更</v-btn>
                                <v-btn v-if="result !== ''" color="primary" text @click="CloseModal">閉じる</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-overlay>
                    <v-overlay :value="addOverlay">
                        <v-card light width="500px">
                            <v-card-title v-if="result === ''">会員情報追加の最終確認</v-card-title>
                            <v-card-title v-if="result !== ''">会員情報追加</v-card-title>
                            <v-card-text v-if="result === ''">会員情報を追加します。</v-card-text>
                            <v-card-text v-if="result !== ''">{{ resultText }}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="result === ''" color="primary" text @click="addOverlay = !addOverlay">キャンセル</v-btn>
                                <v-btn v-if="result === ''" color="primary" text @click="addMember">追加</v-btn>
                                <v-btn v-if="result !== ''" color="primary" text @click="CloseModal">閉じる</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-overlay>
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import { GET_MEMBER, GET_GOLFGROUP, REGISTER_MEMBER, UPDATE_MEMBER, DELETE_MEMBER } from '@/constants/member';
import { GET_SYSTEM_MASTER } from '@/constants/system_master';
import validater from '@/lib/validater';
import { GET_CODE_LIST } from '@/constants/codelist';
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';

export default {
    components: {
        CardTitle
    },
    mixins: [
        authorityMixin,
        utilityMixin
    ],
    data () {
        return {
            // 追加確認用ポップアップ表示に関する制御値
            addOverlay: false,
            // 変更確認用ポップアップ表示に関する制御値
            changeOverlay: false,
            // 削除確認用ポップアップ表示に関する制御値
            removeOverlay: false,
            // 処理結果
            result: '',
            // 処理結果メッセージ
            resultText: '',
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '',
            // 画面のモード指定
            // [値：checkData = 会員情報参照],[値：addMember = 会員追加],[値：changeData = 情報変更]
            modeStatus: '',
            // 必須項目に関するチェック値
            valid: true,
            // 会員追加： 入力項目の活性・非活性制御値
            addStatus: false,
            // 情報変更： 入力項目の活性・非活性制御値
            changeStatus: true,
            // モーダル画面表示制御値
            dialog: false,
            // 生年月日の日付格納用
            date: null,
            // 生年月日カレンダーメニュー表示制御値
            menu: false,
            // バリデーションチェック値
            lazy: false,
            // 情報変更を行う際の制御値
            data_change_flag: false,
            // 入力値管理用
            from_set_data: {
                // フルネーム
                full_name: '',
                // 苗字
                family_name: '',
                // 名前
                given_name: '',
                // 苗字カナ
                family_name_kana: '',
                // 名前カナ
                given_name_kana: '',
                // メールアドレス
                email: '',
                // パスワード
                password: '',
                // 生年月日
                birth_date: '',
                // 携帯番号
                mobile_number: '',
                // 性別
                gender: '0',
                // メンバー会員
                member_rank: '0',
                // 郵便番号
                zipcode: '',
                // 住所１
                address1: '',
                // 住所２
                address2: ''
            },
            golf_groups: [],
            golf_groups_val: [],
            member_no: '',
            // パスワード項目の可視化：非表示
            show_password: false,
            rules: {
                // 氏名（姓）バリデーション
                required_family_name: value => !!value || this.$t('error.validation.required.familyName'),
                max_length_family_name: value => value.length <= 50 || this.$t('error.validation.length.familyName'),
                // 氏名（名）バリデーション
                required_given_name: value => !!value || this.$t('error.validation.required.givenName'),
                max_length_given_name: value => value.length <= 50 || this.$t('error.validation.length.givenName'),
                // 氏名（姓カナ）バリデーション
                required_family_name_kana: value => this.validationRequired(value) || this.$t('error.validation.required.familyNameKana'),
                max_length_family_name_kana: value => value.length <= 50 || this.$t('error.validation.length.familyNameKana'),
                // 氏名（名カナ）バリデーション
                required_given_name_kana: value => this.validationRequired(value) || this.$t('error.validation.required.familyNameKana'),
                max_length_given_name_kana: value => value.length <= 50 || this.$t('error.validation.length.givenNameKana'),
                // カタカナバリデーション
                format_katakana: value => validater.checkZenHanKana(value) || this.$t('error.validation.kataKana'),
                // 生年月日バリデーション
                required_birth_date: value => !!value || this.$t('error.validation.required.birthDate'),
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                // メールアドレスバリデーション
                required_email: value => !!value || this.$t('error.validation.required.email'),
                format_email: value => !!validater.checkMail(value) || this.$t('error.validation.mailFormat'),
                max_length_email: value => value.length <= 256 || this.$t('error.validation.length.mail'),
                // 携帯番号バリデーション
                required_mobile_number: value => this.validationMobileNumber(value) || this.$t('error.validation.required.mobileNumber'),
                format_mobile_number: value => !!validater.checkmobilenumberNoHyphen(value) || this.$t('error.validation.mobileNumber'),
                max_length_mobile_number: value => value.length <= 11 || this.$t('error.validation.length.mobileNumber'),
                // 郵便番号バリデーション
                required_zipcode: value => this.validationRequired(value) || this.$t('error.validation.required.zipcode'),
                format_zipcode: value => !!validater.checkZipCode(value) || this.$t('error.validation.length.zipcode'),
                max_length_zipcode: value => value.length <= 7 || this.$t('error.validation.length.zipcode'),
                // 住所バリデーション
                required_address: value => this.validationRequired(value) || this.$t('error.validation.required.address'),
                max_length_address: value => value.length <= 50 || this.$t('error.validation.length.address'),
                // パスワードバリデーション
                required_password: value => !!value || this.$t('error.validation.required.password'),
                format_password: value => validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                format_password_complexity: value => validater.checkComplexity(value) || this.$t('error.validation.complexity'),
                max_length_password: value => value.length <= 128 || this.$t('error.validation.length.passwordMax'),
                min_length_password: value => value.length >= 8 || this.$t('error.validation.length.passwordMin'),
                // 所属ゴルフグループバリデーション
                required_golf_groups: value => value.length > 0 || this.$t('error.validation.required.affiliationGolfGroup')
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '追加', isActive: true },
                { element_id: '002', element_name: '変更', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0004',
            featuresSms: 0,
            // WEB会員種別ラジオボタン
            items: []
        };
    },
    computed: {
        formatedDate: function () {
            return function (pdate) {
                pdate = this.addHyphen(pdate);
                return pdate;
            };
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        Initialize () {
            this.changeStatus = true;
            this.modeStatus = '';
            this.from_set_data.full_name = '';
            this.from_set_data.family_name = '';
            this.from_set_data.given_name = '';
            this.from_set_data.email = '';
            this.from_set_data.password = '';
            this.from_set_data.birth_date = '1980-01-01';
            this.from_set_data.mobile_number = '';
            this.from_set_data.gender = '0';
            this.from_set_data.member_rank = '0';
            this.from_set_data.family_name_kana = '';
            this.from_set_data.given_name_kana = '';
            this.from_set_data.zipcode = '';
            this.from_set_data.address1 = '';
            this.from_set_data.address2 = '';
            this.data_change_flag = false;
            this.addStatus = false;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.removeOverlay = false;
            this.result = '';
            this.resultText = '';
        },
        /** ----------------------------------------------
         * 会員情報を取得
         * ---------------------------------------------- */
        getMember () {
            this.$apollo.mutate({
                mutation: GET_MEMBER,
                variables: { member_no: this.member_no }
            }).then(res => {
                this.from_set_data.full_name = res.data.getMember.family_name + ' ' + res.data.getMember.given_name;
                this.from_set_data.family_name = res.data.getMember.family_name;
                this.from_set_data.given_name = res.data.getMember.given_name;
                this.from_set_data.gender = String(res.data.getMember.gender);
                this.from_set_data.birth_date = res.data.getMember.birth_date;
                if (res.data.getMember.mobile_number !== null) {
                    this.from_set_data.mobile_number = res.data.getMember.mobile_number;
                }
                this.from_set_data.email = res.data.getMember.email;
                this.from_set_data.member_rank = String(res.data.getMember.member_rank);
                if (res.data.getMember.family_name_kana !== null) {
                    this.from_set_data.family_name_kana = res.data.getMember.family_name_kana;
                }
                if (res.data.getMember.given_name_kana !== null) {
                    this.from_set_data.given_name_kana = res.data.getMember.given_name_kana;
                }
                if (res.data.getMember.zipcode !== null) {
                    this.from_set_data.zipcode = res.data.getMember.zipcode;
                }
                if (res.data.getMember.address1 !== null) {
                    this.from_set_data.address1 = res.data.getMember.address1;
                }
                if (res.data.getMember.address2 !== null) {
                    this.from_set_data.address2 = res.data.getMember.address2;
                }
            });
        },
        /** ----------------------------------------------
         * ゴルフグループを取得
         * ---------------------------------------------- */
        async getGolfGroup () {
            await this.$apollo.mutate({
                mutation: GET_GOLFGROUP,
                variables: {}
            }).then(res => {
                this.golf_groups = res.data.golfGroup;
                this.golf_groups_val = process.env.VUE_APP_GROUP_CODE;
            });
        },
        /** ----------------------------------------------
         * 会員情報追加
         * ---------------------------------------------- */
        addMember () {
            this.$apollo.mutate({
                mutation: REGISTER_MEMBER,
                variables: {
                    family_name: this.from_set_data.family_name,
                    given_name: this.from_set_data.given_name,
                    gender: parseInt(this.from_set_data.gender),
                    birth_date: this.from_set_data.birth_date,
                    mobile_number: this.from_set_data.mobile_number,
                    email: this.from_set_data.email,
                    password: this.from_set_data.password,
                    member_rank: this.from_set_data.member_rank,
                    family_name_kana: this.hankanaChangeZenkana(this.from_set_data.family_name_kana),
                    given_name_kana: this.hankanaChangeZenkana(this.from_set_data.given_name_kana),
                    zipcode: this.from_set_data.zipcode,
                    address1: this.from_set_data.address1,
                    address2: this.from_set_data.address2
                }
            }).then(res => {
                this.result = res.data.adminCreateMember.result;
                // 結果、正常であれば所属ゴルフグループ情報に登録
                if (this.result === 1) {
                    this.member_no = res.data.adminCreateMember.member_no;
                    this.resultText = this.$t('result.success.add');
                } else {
                    this.resultText = this.$t('result.error.add');
                }
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.add');
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 会員情報変更
         * ---------------------------------------------- */
        changeMember () {
            this.$apollo.mutate({
                mutation: UPDATE_MEMBER,
                variables: {
                    member_no: this.member_no,
                    family_name: this.from_set_data.family_name,
                    given_name: this.from_set_data.given_name,
                    gender: parseInt(this.from_set_data.gender),
                    birth_date: this.from_set_data.birth_date,
                    mobile_number: this.from_set_data.mobile_number,
                    email: this.from_set_data.email,
                    member_rank: this.from_set_data.member_rank,
                    family_name_kana: this.hankanaChangeZenkana(this.from_set_data.family_name_kana),
                    given_name_kana: this.hankanaChangeZenkana(this.from_set_data.given_name_kana),
                    zipcode: this.from_set_data.zipcode,
                    address1: this.from_set_data.address1,
                    address2: this.from_set_data.address2
                }
            }).then(res => {
                this.result = res.data.adminUpdateMember.result;
                if (this.result === 1) {
                    this.resultText = this.$t('result.success.change');
                } else if (this.result === 2) {
                    this.resultText = this.$t('result.error.withdrawn');
                } else {
                    this.resultText = this.$t('result.error.change');
                }
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.change');
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 会員情報削除
         * ---------------------------------------------- */
        removeMember () {
            this.$apollo.mutate({
                mutation: DELETE_MEMBER,
                variables: { member_no: this.member_no }
            }).then(res => {
                this.result = res.data.adminDeleteMember.result;
                if (this.result === 1) {
                    this.resultText = this.$t('result.success.remove');
                } else if (this.result === 9) {
                    this.resultText = this.$t('result.error.existsReserve');
                } else {
                    this.resultText = this.$t('result.error.remove');
                }
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.remove');
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.member_form.validate()) {
                if (this.modeStatus === 'addMember') {
                    this.addOverlay = true;
                } else if (this.modeStatus === 'changeData') {
                    this.changeOverlay = true;
                }
            }
        },
        /** ----------------------------------------------
         * 必須チェック処理
         * ---------------------------------------------- */
        validationRequired (value) {
            // クラシックの場合
            if (process.env.VUE_APP_NAME === 'hcgc') {
                if (value.length === 0) {
                    return false;
                }
            }

            return true;
        },
        /** ----------------------------------------------
         * 携帯番号チェック処理
         * ---------------------------------------------- */
        validationMobileNumber (value) {
            // SMS機能が有効の場合
            if (this.featuresSms === 1) {
                if (value.length === 0) {
                    return false;
                }
            }

            return true;
        },

        getCodeList () {
            this.$apollo.query({
                query: GET_CODE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    code_key: 'member_status_type',
                    default_display: 0
                }
            }).then(res => {
                this.items = res.data.GetCodeList.CodeList;
            });
        },
        /** ----------------------------------------------
         * SMS機能の有無取得
         * ---------------------------------------------- */
        getFeaturesSms () {
            try {
                this.$apollo.query({
                    query: GET_SYSTEM_MASTER,
                    fetchPolicy: 'no-cache',
                    variables: {
                        settingGroup: 'features_option',
                        settingKey: 'features_sms'
                    }
                }).then(res => {
                    this.featuresSms = res.data.GetSystemMaster.SystemMasterLists[0].setting_value;
                    this.$store.commit('loading/setIsLoading', false);
                });
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },

        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUp (event) {
            this.from_set_data.birth_date = this.formatDate(this.from_set_data.birth_date);
            this.from_set_data.birth_date = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * 親画面にて「会員追加」ボタン押下時の処理
         * @param val モーダル画面の表示用制御値
         * @param mode 画面のモード指定
         * ---------------------------------------------- */
        ModalControl: function (val, mode) {
            this.Initialize();
            this.getAuthority();
            this.page_title = '会員追加';
            this.modeStatus = mode;
            this.addStatus = false;
            this.changeStatus = false;
            this.getGolfGroup();
            this.getCodeList();
            this.getFeaturesSms();
            this.dialog = val;
            this.data_change_flag = true;
        },
        /** ----------------------------------------------
         * 親画面にて「詳細表示」ボタン押下時の処理
         * 親画面から渡ってきたデータを各項目に渡す
         * @param val モーダル画面の表示用制御値
         * @param el 押下したボタンに紐づく行内の各データ
         * @param mode 画面のモード指定
         * ---------------------------------------------- */
        async InfoMemberModal (val, el, mode) {
            this.Initialize();
            this.getAuthority();
            this.page_title = '会員情報参照';
            this.modeStatus = mode;
            this.addStatus = true;
            this.changeStatus = true;
            this.member_no = el.member_no;
            this.getMember();
            this.getCodeList();
            this.getFeaturesSms();
            await this.getGolfGroup();
            this.dialog = val;
        },
        /** ----------------------------------------------
         * 詳細表示画面表示に情報変更ボタンを押下した際の処理
         * ---------------------------------------------- */
        InfoChangeData () {
            this.page_title = '会員情報変更';
            this.modeStatus = 'changeData';
            this.addStatus = true;
            this.changeStatus = false;
            this.data_change_flag = true;
        },
        // /** ----------------------------------------------
        //  * カレンダーで日付をカレンダー自身に保持させる処理
        //  * @param date 指定した日付データ
        //  * ---------------------------------------------- */
        // SaveData (date) {
        //     this.$refs.menu.SaveData(date);
        // },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.$refs.member_form.resetValidation();
            this.dialog = false;
            this.$emit('refresh-event');
            this.Initialize();
        }
    }
};
</script>
